/* Vue sur Mur : « Voir dans ma pièce ».
   La cliente photographie son mur : le mur est repéré automatiquement (segmentation sur le téléphone,
   la photo n'est envoyée nulle part), le décor s'y pose en perspective, derrière les meubles et les cadres.
   Réglages facultatifs : cadre (4 coins), retouches au doigt, mesures. Autres décors, image à garder. */
(() => {
  const dlg = document.querySelector('[data-vsm-room]');
  if (!dlg || dlg.dataset.ready) return;
  dlg.dataset.ready = '1';

  let DATA;
  try { DATA = JSON.parse(dlg.querySelector('[data-room-data]').textContent); } catch (e) { return; }
  const $ = (s, el) => (el || dlg).querySelector(s);
  const $$ = (s, el) => [...(el || dlg).querySelectorAll(s)];
  const pdp = () => window.VSM_PDP || null;
  const STORE = 'vsm-room-v3';
  const MAXPX = 2048;

  /* Repérage du mur : SegFormer (ADE20K, classe 0 = mur), exécuté dans le navigateur */
  const ORT_BASE = 'https://cdn.jsdelivr.net/npm/onnxruntime-web@1.20.1/dist/';
  const MODEL_URL = 'https://huggingface.co/Xenova/segformer-b1-finetuned-ade-512-512/resolve/main/onnx/model_quantized.onnx';
  const MODEL_CACHE = 'vsm-room-model-v1';
  const SEG_IN = 768;

  /* ---------- État ---------- */
  const S = {
    photo: null, pw: 0, ph: 0,
    quad: null, autoQuad: null,     // [x0,y0,x1,y1,x2,y2,x3,y3] px photo : HG, HD, BD, BG
    decor: DATA.products.find((p) => p.id === DATA.current) || DATA.products[0],
    decorImg: null,
    w: 300, h: 250, cx: 0.5, cy: 0.5,
    light: 0.8,
    mode: 'view', tool: 'erase', size: 28,
    show: 1, busy: false,
    mask: null, maskCtx: null, maskDirty: true, segMask: null,
    undo: [], avg: 0.6,
    lightCv: null,
  };

  /* ---------- Éléments ---------- */
  const pick = $('[data-room-pick]'), edit = $('[data-room-edit]');
  const stage = $('[data-room-stage]'), fit = $('[data-room-fit]'), cv = $('[data-room-gl]');
  const quadSvg = $('[data-room-quad] polygon'), handles = $$('[data-room-handle]');
  const loupe = $('[data-room-loupe]'), lctx = loupe.getContext('2d');
  const brush = $('[data-room-brush]'), hint = $('[data-room-hint]');
  const err = $('[data-room-err]'), saveBtn = $('[data-room-save]');
  const strip = $('[data-room-strip]');
  const scan = $('[data-room-scan]'), scanT = $('[data-room-scan-t]'), scanBar = $('[data-room-scan-bar]');

  /* =====================================================================
     Ouvrir / fermer
     ===================================================================== */
  function syncFromPdp() {
    const P = pdp();
    if (!P) return;
    const g = P.get();
    if (g.w && g.h && g.valid) { S.w = g.w; S.h = g.h; }
    if (S.decor.id === DATA.current) { S.cx = g.cx; S.cy = g.cy; }
  }
  function open() {
    syncFromPdp();
    setDecorUI();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.documentElement.classList.add('vsm-room-open');
    if (!S.decorImg) setDecor(S.decor, true);
    prepareSeg().catch(() => {});           /* téléchargement de l'outil pendant qu'elle prend sa photo */
    if (!S.photo) restore();
    if (S.photo) showEdit(); else showPick();
  }
  function close() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', () => { document.documentElement.classList.remove('vsm-room-open'); persist(); });
  $('[data-room-close]').addEventListener('click', close);
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-open-room]');
    if (!b) return;
    e.preventDefault();
    open();
  });

  function showPick() {
    pick.hidden = false; edit.hidden = true; saveBtn.hidden = true;
    $('[data-room-pick-img]').src = S.decor.th;
    $('[data-room-pick-name]').textContent = S.decor.t;
  }
  function showEdit() {
    pick.hidden = true; edit.hidden = false; saveBtn.hidden = false;
    requestAnimationFrame(() => { layout(); draw(); });
  }

  /* =====================================================================
     Photo
     ===================================================================== */
  $$('[data-room-file]').forEach((inp) => inp.addEventListener('change', async () => {
    const f = inp.files && inp.files[0];
    inp.value = '';
    if (!f) return;
    err.hidden = true;
    try { await loadPhoto(f); }
    catch (e) {
      err.textContent = 'Cette photo n’a pas pu être ouverte. Essayez avec une autre.';
      err.hidden = false;
      return;
    }
    S.undo = []; S.segMask = null; S.autoQuad = null;
    resetQuad(); fillMask(255);
    setMode('view');
    showEdit();
    await analyse();
  }));

  async function decodeFile(f) {
    if ('createImageBitmap' in window) {
      try { return await createImageBitmap(f, { imageOrientation: 'from-image' }); } catch (e) {}
    }
    return await new Promise((res, rej) => {
      const url = URL.createObjectURL(f), im = new Image();
      im.onload = () => res(im);
      im.onerror = rej; im.src = url;
    });
  }
  async function loadPhoto(f) {
    const bmp = await decodeFile(f);
    setPhoto(bmp, bmp.width || bmp.naturalWidth, bmp.height || bmp.naturalHeight);
  }
  function setPhoto(src, w0, h0) {
    const k = Math.min(1, MAXPX / Math.max(w0, h0));
    const w = Math.round(w0 * k), h = Math.round(h0 * k);
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    c.getContext('2d').drawImage(src, 0, 0, w, h);
    S.photo = c; S.pw = w; S.ph = h; S.photoURL = null;
    S.mask = document.createElement('canvas');
    S.mask.width = Math.round(w / 2); S.mask.height = Math.round(h / 2);
    S.maskCtx = S.mask.getContext('2d');
    fillMask(255);
    buildLight(null);
    if (gl) uploadPhoto();
  }
  function fillMask(v) {
    if (!S.maskCtx) return;
    S.maskCtx.fillStyle = 'rgb(' + v + ',' + v + ',' + v + ')';
    S.maskCtx.fillRect(0, 0, S.mask.width, S.mask.height);
    S.maskDirty = true;
  }
  function resetQuad() {
    if (S.autoQuad) { S.quad = S.autoQuad.slice(); quadChanged(); return; }
    const r = S.w / S.h;
    let qw = S.pw * 0.7, qh = qw / r;
    if (qh > S.ph * 0.7) { qh = S.ph * 0.7; qw = qh * r; }
    const x = (S.pw - qw) / 2, y = (S.ph - qh) / 2;
    S.quad = [x, y, x + qw, y, x + qw, y + qh, x, y + qh];
    quadChanged();
  }

  /* =====================================================================
     Repérage automatique du mur
     ===================================================================== */
  let segPromise = null;
  function loadScript(src) {
    return new Promise((res, rej) => {
      if (window.ort) return res();
      const s = document.createElement('script');
      s.src = src; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  let dlProgress = 0;
  async function fetchModel() {
    let cache = null;
    try { cache = await caches.open(MODEL_CACHE); const hit = await cache.match(MODEL_URL); if (hit) { dlProgress = 1; return await hit.arrayBuffer(); } } catch (e) { cache = null; }
    const res = await fetch(MODEL_URL, { mode: 'cors' });
    if (!res.ok) throw new Error('model ' + res.status);
    const total = +res.headers.get('content-length') || 14500000;
    let buf;
    if (res.body && res.body.getReader) {
      const rd = res.body.getReader(), parts = [];
      let got = 0;
      for (;;) {
        const { done, value } = await rd.read();
        if (done) break;
        parts.push(value); got += value.length;
        dlProgress = Math.min(0.99, got / total);
      }
      const all = new Uint8Array(got); let o = 0;
      parts.forEach((p) => { all.set(p, o); o += p.length; });
      buf = all.buffer;
    } else { buf = await res.arrayBuffer(); }
    dlProgress = 1;
    if (cache) { try { await cache.put(MODEL_URL, new Response(buf.slice(0), { headers: { 'Content-Type': 'application/octet-stream' } })); } catch (e) {} }
    return buf;
  }
  function prepareSeg() {
    if (!segPromise) {
      segPromise = (async () => {
        const [buf] = await Promise.all([fetchModel(), loadScript(ORT_BASE + 'ort.wasm.min.js')]);
        const ort = window.ort;
        ort.env.wasm.wasmPaths = ORT_BASE;
        ort.env.wasm.numThreads = 1;
        return await ort.InferenceSession.create(buf, { executionProviders: ['wasm'], graphOptimizationLevel: 'all' });
      })();
      segPromise.catch(() => { segPromise = null; });
    }
    return segPromise;
  }

  function showScan(on, text) {
    scan.hidden = !on;
    edit.classList.toggle('is-scanning', on);
    if (text) scanT.textContent = text;
  }
  async function analyse() {
    S.busy = true; draw();
    showScan(true, 'Je repère votre mur…');
    const tick = setInterval(() => {
      if (dlProgress < 1) { scanT.textContent = 'Préparation de l’outil… ' + Math.round(dlProgress * 100) + ' %'; scanBar.style.setProperty('--p', dlProgress); }
      else { scanT.textContent = 'Je repère votre mur…'; scanBar.style.setProperty('--p', 1); }
    }, 200);
    let ok = false;
    try {
      const sess = await prepareSeg();
      clearInterval(tick);
      scanT.textContent = 'Je repère votre mur…';
      await new Promise((r) => setTimeout(r, 30));
      const seg = await segment(sess);
      ok = applySeg(seg);
    } catch (e) { ok = false; }
    clearInterval(tick);
    S.busy = false;
    showScan(false);
    if (ok) {
      setHint('Votre mur est habillé. Le cadre n’est pas juste ? Touchez « Ajuster le cadre ».', 7000);
    } else {
      resetQuad(); fillMask(255); buildLight(null);
      setMode('place');
      setHint('Placez les 4 ronds sur les angles de votre mur', 7000);
    }
    draw(); persistSoon();
  }

  async function segment(sess) {
    /* proportions de la photo respectées, grand côté à 768 px (plus de détails autour des objets) */
    const ort = window.ort, k = SEG_IN / Math.max(S.pw, S.ph);
    const NW = Math.max(64, Math.round(S.pw * k / 32) * 32), NH = Math.max(64, Math.round(S.ph * k / 32) * 32);
    const c = document.createElement('canvas'); c.width = NW; c.height = NH;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(S.photo, 0, 0, NW, NH);
    const d = x.getImageData(0, 0, NW, NH).data, hw = NW * NH;
    const t = new Float32Array(3 * hw);
    const mean = [0.485, 0.456, 0.406], std = [0.229, 0.224, 0.225];
    for (let i = 0; i < hw; i++) {
      t[i] = (d[i * 4] / 255 - mean[0]) / std[0];
      t[hw + i] = (d[i * 4 + 1] / 255 - mean[1]) / std[1];
      t[2 * hw + i] = (d[i * 4 + 2] / 255 - mean[2]) / std[2];
    }
    const out = await sess.run({ [sess.inputNames[0]]: new ort.Tensor('float32', t, [1, 3, NH, NW]) });
    const lg = out[sess.outputNames[0]];
    const C = lg.dims[1], H = lg.dims[2], W = lg.dims[3], L = lg.data, n = H * W;
    const prob = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      let m = -1e9;
      for (let k = 0; k < C; k++) { const v = L[k * n + i]; if (v > m) m = v; }
      let s = 0;
      for (let k = 0; k < C; k++) s += Math.exp(L[k * n + i] - m);
      prob[i] = Math.exp(L[i] - m) / s;
    }
    return { prob, W, H };
  }

  /* Droite robuste (y = a·x + b) qui épouse le bord du mur malgré les meubles et les lampes */
  function envelope(pts, side) {
    if (pts.length < 2) return null;
    let best = null, bestScore = -1e9;
    const n = pts.length, tries = Math.min(600, n * n);
    for (let t = 0; t < tries; t++) {
      const p = pts[(Math.random() * n) | 0], q = pts[(Math.random() * n) | 0];
      if (Math.abs(q[0] - p[0]) < 3) continue;
      const a = (q[1] - p[1]) / (q[0] - p[0]);
      if (Math.abs(a) > 0.7) continue;
      const b = p[1] - a * p[0];
      let inl = 0, bad = 0;
      for (const r of pts) {
        const dy = r[1] - (a * r[0] + b);
        if (Math.abs(dy) <= 1.5) inl++;
        else if (side === 'top' ? dy < -2 : dy > 2) bad++;
      }
      const sc = inl - 2.5 * bad;
      if (sc > bestScore) { bestScore = sc; best = [a, b]; }
    }
    /* droite horizontale de secours */
    const ys = pts.map((p) => p[1]).sort((u, v) => u - v);
    const flat = [0, side === 'top' ? ys[Math.floor(ys.length * 0.1)] : ys[Math.floor(ys.length * 0.9)]];
    if (!best) return flat;
    /* affinage sur les points en accord */
    let sx = 0, sy = 0, sxx = 0, sxy = 0, k = 0;
    for (const r of pts) {
      if (Math.abs(r[1] - (best[0] * r[0] + best[1])) <= 1.5) { sx += r[0]; sy += r[1]; sxx += r[0] * r[0]; sxy += r[0] * r[1]; k++; }
    }
    if (k >= 4) {
      const den = k * sxx - sx * sx;
      if (Math.abs(den) > 1e-6) { const a = (k * sxy - sx * sy) / den; if (Math.abs(a) <= 0.7) best = [a, (sy - a * sx) / k]; }
    }
    return best;
  }

  function applySeg(seg) {
    const { prob, W, H } = seg, n = W * H;
    /* plus grande zone de mur */
    const lab = new Int32Array(n), stack = new Int32Array(n);
    let bestL = 0, bestN = 0, L = 0;
    for (let i = 0; i < n; i++) {
      if (lab[i] || prob[i] < 0.5) continue;
      L++; let sp = 0, cnt = 0; stack[sp++] = i; lab[i] = L;
      while (sp) {
        const j = stack[--sp]; cnt++;
        const x = j % W, y = (j / W) | 0;
        const nb = [x > 0 ? j - 1 : -1, x < W - 1 ? j + 1 : -1, y > 0 ? j - W : -1, y < H - 1 ? j + W : -1];
        for (const q of nb) if (q >= 0 && !lab[q] && prob[q] >= 0.5) { lab[q] = L; stack[sp++] = q; }
      }
      if (cnt > bestN) { bestN = cnt; bestL = L; }
    }
    if (bestN < n * 0.04) return false;
    /* bords haut et bas, colonne par colonne */
    const top = new Int32Array(W).fill(-1), bot = new Int32Array(W).fill(-1), cnt = new Int32Array(W);
    for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) {
      if (lab[y * W + x] !== bestL) continue;
      if (top[x] < 0) top[x] = y;
      bot[x] = y; cnt[x]++;
    }
    let mx = 0; for (let x = 0; x < W; x++) mx = Math.max(mx, cnt[x]);
    const valid = []; for (let x = 0; x < W; x++) if (cnt[x] >= mx * 0.2) valid.push(x);
    if (valid.length < W * 0.12) return false;
    const xl = valid[0], xr = valid[valid.length - 1] + 1;
    const tl = envelope(valid.map((x) => [x + 0.5, top[x]]), 'top');
    const bl = envelope(valid.map((x) => [x + 0.5, bot[x] + 1]), 'bot');
    if (!tl || !bl) return false;
    const kx = S.pw / W, ky = S.ph / H;
    const yAt = (ln, x) => ln[0] * x + ln[1];
    const ext = (x) => (x <= 0.5 ? -0.02 * W : x >= W - 0.5 ? W * 1.02 : x);
    const X0 = ext(xl), X1 = ext(xr);
    const q = [X0, yAt(tl, X0), X1, yAt(tl, X1), X1, yAt(bl, X1), X0, yAt(bl, X0)];
    for (let i = 0; i < 8; i += 2) {
      q[i] *= kx;
      let y = q[i + 1];
      if (i < 4 && y <= 0.6) y = -0.02 * H;              /* le mur continue au-dessus de la photo */
      if (i >= 4 && y >= H - 0.6) y = H * 1.02;          /* … ou sous la photo */
      q[i + 1] = y * ky;
    }
    if (q[5] - q[3] < S.ph * 0.15 || q[2] - q[0] < S.pw * 0.15) return false;
    S.autoQuad = q.slice();
    S.quad = q;
    /* masque : probabilité de mur, recalée sur les vrais contours de la photo (filtre guidé) */
    const pc = document.createElement('canvas'); pc.width = W; pc.height = H;
    const px = pc.getContext('2d'), im = px.createImageData(W, H);
    for (let i = 0; i < n; i++) { const v = Math.round(prob[i] * 255); im.data[i * 4] = im.data[i * 4 + 1] = im.data[i * 4 + 2] = v; im.data[i * 4 + 3] = 255; }
    px.putImageData(im, 0, 0);
    S.maskCtx.imageSmoothingEnabled = true; S.maskCtx.imageSmoothingQuality = 'high';
    S.maskCtx.drawImage(pc, 0, 0, S.mask.width, S.mask.height);
    try { refineMask(); } catch (e) {}
    S.segMask = S.maskCtx.getImageData(0, 0, S.mask.width, S.mask.height);
    S.maskDirty = true;
    buildLight(seg);
    quadChanged();
    return true;
  }

  /* Filtre guidé (He et al.) : le masque épouse les contours nets de la photo */
  function boxBlur(src, w, h, r) {
    const out = new Float32Array(w * h), ii = new Float64Array((w + 1) * (h + 1));
    for (let y = 0; y < h; y++) {
      let row = 0;
      for (let x = 0; x < w; x++) { row += src[y * w + x]; ii[(y + 1) * (w + 1) + x + 1] = ii[y * (w + 1) + x + 1] + row; }
    }
    for (let y = 0; y < h; y++) {
      const y0 = Math.max(0, y - r), y1 = Math.min(h, y + r + 1);
      for (let x = 0; x < w; x++) {
        const x0 = Math.max(0, x - r), x1 = Math.min(w, x + r + 1);
        const s = ii[y1 * (w + 1) + x1] - ii[y0 * (w + 1) + x1] - ii[y1 * (w + 1) + x0] + ii[y0 * (w + 1) + x0];
        out[y * w + x] = s / ((x1 - x0) * (y1 - y0));
      }
    }
    return out;
  }
  function refineMask() {
    const w = S.mask.width, h = S.mask.height, n = w * h;
    const g = document.createElement('canvas'); g.width = w; g.height = h;
    const gx = g.getContext('2d', { willReadFrequently: true });
    gx.drawImage(S.photo, 0, 0, w, h);
    const gd = gx.getImageData(0, 0, w, h).data;
    const md = S.maskCtx.getImageData(0, 0, w, h);
    const I = new Float32Array(n), P = new Float32Array(n), II = new Float32Array(n), IP = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      const v = (0.299 * gd[i * 4] + 0.587 * gd[i * 4 + 1] + 0.114 * gd[i * 4 + 2]) / 255;
      const p = md.data[i * 4] / 255;
      I[i] = v; P[i] = p; II[i] = v * v; IP[i] = v * p;
    }
    const r = Math.max(3, Math.round(Math.max(w, h) / 200)), eps = 0.002;
    const mI = boxBlur(I, w, h, r), mP = boxBlur(P, w, h, r), mII = boxBlur(II, w, h, r), mIP = boxBlur(IP, w, h, r);
    const A = new Float32Array(n), B = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      const va = mII[i] - mI[i] * mI[i], cv2 = mIP[i] - mI[i] * mP[i];
      A[i] = cv2 / (va + eps); B[i] = mP[i] - A[i] * mI[i];
    }
    const mA = boxBlur(A, w, h, r), mB = boxBlur(B, w, h, r);
    for (let i = 0; i < n; i++) {
      let q = mA[i] * I[i] + mB[i];
      /* là où le modèle est sûr de lui, on ne laisse pas le filtre le contredire */
      if (P[i] > 0.85) q = Math.max(q, P[i]); else if (P[i] < 0.15) q = Math.min(q, P[i]);
      const v = Math.round(Math.max(0, Math.min(1, q)) * 255);
      md.data[i * 4] = md.data[i * 4 + 1] = md.data[i * 4 + 2] = v;
    }
    S.maskCtx.putImageData(md, 0, 0);
  }

  /* Lumière de la pièce, mesurée sur le mur seulement (les meubles ne la faussent pas) */
  function buildLight(seg) {
    if (!S.photo) return;
    const w = 96, h = Math.max(8, Math.round(96 * S.ph / S.pw));
    const c = document.createElement('canvas'); c.width = w; c.height = h;
    const x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(S.photo, 0, 0, w, h);
    const d = x.getImageData(0, 0, w, h).data, n = w * h;
    const lum = new Float32Array(n), wt = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      lum[i] = (0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2]) / 255;
      let p = 1;
      if (seg) { const sx = Math.min(seg.W - 1, ((i % w) + 0.5) / w * seg.W | 0), sy = Math.min(seg.H - 1, (((i / w) | 0) + 0.5) / h * seg.H | 0); p = seg.prob[sy * seg.W + sx]; p = p > 0.5 ? 1 : 0.02; }
      wt[i] = p;
    }
    const blur = (src) => {
      const r = 4, a = new Float32Array(n), b = new Float32Array(n);
      for (let y = 0; y < h; y++) for (let xx = 0; xx < w; xx++) { let s = 0; for (let k = -r; k <= r; k++) { const q = Math.min(w - 1, Math.max(0, xx + k)); s += src[y * w + q]; } a[y * w + xx] = s; }
      for (let y = 0; y < h; y++) for (let xx = 0; xx < w; xx++) { let s = 0; for (let k = -r; k <= r; k++) { const q = Math.min(h - 1, Math.max(0, y + k)); s += a[q * w + xx]; } b[y * w + xx] = s; }
      return b;
    };
    const lw = new Float32Array(n); for (let i = 0; i < n; i++) lw[i] = lum[i] * wt[i];
    const A = blur(lw), B = blur(wt);
    let tot = 0, tw = 0, cr = 0, cg = 0, cb = 0;
    for (let i = 0; i < n; i++) { tot += lw[i]; tw += wt[i]; cr += d[i * 4] * wt[i]; cg += d[i * 4 + 1] * wt[i]; cb += d[i * 4 + 2] * wt[i]; }
    /* teinte de l'éclairage (lumière chaude, froide) relevée sur le mur */
    if (tw > 0) {
      const m3 = (cr + cg + cb) / 3 || 1;
      S.tint = [cr / m3, cg / m3, cb / m3].map((v) => Math.max(0.85, Math.min(1.15, v)));
    } else S.tint = [1, 1, 1];
    const g = tw ? tot / tw : 0.6;
    const out = x.createImageData(w, h);
    S.lightVals = new Float32Array(n);
    for (let i = 0; i < n; i++) {
      const v = B[i] > 0.5 ? A[i] / B[i] : g;
      S.lightVals[i] = v;
      const c8 = Math.round(Math.min(1, v) * 255);
      out.data[i * 4] = out.data[i * 4 + 1] = out.data[i * 4 + 2] = c8; out.data[i * 4 + 3] = 255;
    }
    x.putImageData(out, 0, 0);
    S.lightCv = c; S.lightW = w; S.lightH = h;
    if (gl) upload('L', c);
  }

  /* =====================================================================
     Homographie
     ===================================================================== */
  function sq2quad(q) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = q;
    const dx1 = x1 - x2, dx2 = x3 - x2, dy1 = y1 - y2, dy2 = y3 - y2;
    const sx = x0 - x1 + x2 - x3, sy = y0 - y1 + y2 - y3;
    let g = 0, h = 0;
    if (Math.abs(sx) > 1e-9 || Math.abs(sy) > 1e-9) {
      const den = dx1 * dy2 - dx2 * dy1;
      g = (sx * dy2 - dx2 * sy) / den;
      h = (dx1 * sy - sx * dy1) / den;
    }
    return [x1 - x0 + g * x1, x3 - x0 + h * x3, x0, y1 - y0 + g * y1, y3 - y0 + h * y3, y0, g, h, 1];
  }
  function inv3(m) {
    const [a, b, c, d, e, f, g, h, i] = m;
    const A = e * i - f * h, B = -(d * i - f * g), C = d * h - e * g;
    const det = a * A + b * B + c * C;
    if (Math.abs(det) < 1e-12) return null;
    return [A / det, -(b * i - c * h) / det, (b * f - c * e) / det,
            B / det, (a * i - c * g) / det, -(a * f - c * d) / det,
            C / det, -(a * h - b * g) / det, (a * e - b * d) / det];
  }
  function apply(m, x, y) {
    const z = m[6] * x + m[7] * y + m[8];
    return [(m[0] * x + m[1] * y + m[2]) / z, (m[3] * x + m[4] * y + m[5]) / z];
  }
  let Hinv = null;
  function quadChanged() {
    Hinv = inv3(sq2quad(S.quad));
    /* lumière moyenne du mur dans le cadre */
    if (S.lightVals && Hinv) {
      const w = S.lightW, h = S.lightH, kx = S.pw / w, ky = S.ph / h;
      let s = 0, k = 0;
      for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
        const st = apply(Hinv, (x + 0.5) * kx, (y + 0.5) * ky);
        if (st[0] < 0 || st[0] > 1 || st[1] < 0 || st[1] > 1) continue;
        s += S.lightVals[y * w + x]; k++;
      }
      S.avg = k ? Math.max(0.08, s / k) : 0.6;
    }
    placeHandles();
    draw();
  }

  /* =====================================================================
     Cadrage du décor (même calcul que le configurateur)
     ===================================================================== */
  function cropRect() {
    const d = S.decor, W = S.w, H = S.h, r = W / H, ir = d.r || 1.5;
    const fw = r, fh = 1;
    let iw, ih;
    if (d.m === 'raccord') {
      iw = fw * ((d.mc || 100) / W); ih = iw / ir;
      if (iw < fw) { iw = fw; ih = iw / ir; }
      if (ih < fh) { ih = fh; iw = ih * ir; }
    } else if (ir > r) { ih = fh; iw = fh * ir; } else { iw = fw; ih = fw / ir; }
    const vw = Math.min(1, fw / iw), vh = Math.min(1, fh / ih);
    const cl = (v, a, b) => (a >= b ? 0.5 : Math.max(a, Math.min(b, v)));
    S.cx = cl(S.cx, vw / 2, 1 - vw / 2); S.cy = cl(S.cy, vh / 2, 1 - vh / 2);
    return [S.cx - vw / 2, S.cy - vh / 2, vw, vh];
  }

  /* =====================================================================
     WebGL
     ===================================================================== */
  let gl = null, prog = null, isGL2 = false;
  const U = {}, tex = {};
  const VS = 'attribute vec2 p;varying vec2 v;void main(){v=vec2(p.x*.5+.5,.5-p.y*.5);gl_Position=vec4(p,0.,1.);}';
  const FS = [
    'precision highp float;',
    'varying vec2 v;',
    'uniform sampler2D uP,uD,uM,uL;',
    'uniform mat3 uH;uniform vec2 uS;uniform vec4 uC;',
    'uniform float uA,uK,uShow,uE,uLes,uSeam;',
    'uniform vec3 uT;',
    'void main(){',
    ' vec3 p=texture2D(uP,v).rgb;',
    ' vec3 q=uH*vec3(v*uS,1.);',
    ' vec2 st=q.xy/q.z;',
    ' float e=uE;',
    ' float ins=smoothstep(0.,e,st.x)*smoothstep(0.,e,1.-st.x)*smoothstep(0.,e,st.y)*smoothstep(0.,e,1.-st.y);',
    ' if(q.z<=0.)ins=0.;',
    ' vec3 d=texture2D(uD,uC.xy+clamp(st,0.,1.)*uC.zw).rgb;',
    ' d=mix(d,vec3(dot(d,vec3(.299,.587,.114))),.07)*.93+.035;',
    ' float l=texture2D(uL,v).r;',
    ' float s=clamp(l/uA,.45,1.4);',
    ' vec3 lit=d*mix(1.,s,uK)*mix(vec3(1.),uT,.7*uK);',
    ' float lx=st.x*uLes;',
    ' if(lx>.5&&lx<uLes-.5){float f=abs(fract(lx+.5)-.5)/uLes;lit*=1.-.09*(1.-smoothstep(0.,uSeam,f))+.04*(smoothstep(uSeam,uSeam*2.,f)-smoothstep(uSeam*2.,uSeam*3.,f));}',
    ' float gr=fract(sin(dot(gl_FragCoord.xy,vec2(12.9898,78.233)))*43758.5453);',
    ' lit+=(gr-.5)*.022;',
    ' float m=smoothstep(.32,.68,texture2D(uM,v).r);',
    ' float a=ins*m*uShow;',
    ' gl_FragColor=vec4(mix(p,lit,a),1.);',
    '}'].join('\n');

  function initGL() {
    const opt = { preserveDrawingBuffer: true, antialias: false, premultipliedAlpha: false, alpha: false };
    gl = cv.getContext('webgl2', opt);
    isGL2 = !!gl;
    if (!gl) gl = cv.getContext('webgl', opt) || cv.getContext('experimental-webgl', opt);
    if (!gl) return false;
    const sh = (t, s) => { const o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; };
    prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, VS));
    gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FS));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return false;
    gl.useProgram(prog);
    const b = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    const loc = gl.getAttribLocation(prog, 'p');
    gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    ['uP', 'uD', 'uM', 'uL', 'uH', 'uS', 'uC', 'uA', 'uK', 'uShow', 'uE', 'uLes', 'uSeam', 'uT'].forEach((n) => { U[n] = gl.getUniformLocation(prog, n); });
    ['P', 'D', 'M', 'L'].forEach((n, i) => {
      const t = gl.createTexture();
      gl.activeTexture(gl.TEXTURE0 + i); gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, new Uint8Array([255, 255, 255, 255]));
      gl.uniform1i(U['u' + n], i);
      tex[n] = t;
    });
    return true;
  }
  function upload(name, src, mip) {
    const i = ['P', 'D', 'M', 'L'].indexOf(name);
    gl.activeTexture(gl.TEXTURE0 + i); gl.bindTexture(gl.TEXTURE_2D, tex[name]);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, src);
    if (mip && isGL2) {
      gl.generateMipmap(gl.TEXTURE_2D);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
    }
  }
  function uploadPhoto() {
    cv.width = S.pw; cv.height = S.ph;
    gl.viewport(0, 0, S.pw, S.ph);
    upload('P', S.photo);
    if (S.lightCv) upload('L', S.lightCv);
    S.maskDirty = true;
  }

  /* =====================================================================
     Décor
     ===================================================================== */
  function loadDecor(d) {
    return new Promise((res) => {
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = () => res(im);
      im.onerror = () => res(null);
      im.src = d.i.startsWith('//') ? location.protocol + d.i : d.i;
    });
  }
  let decorToken = 0;
  async function setDecor(d, keepCrop) {
    S.decor = d;
    if (!keepCrop) { S.cx = 0.5; S.cy = 0.5; }
    if (d.id === DATA.current) syncFromPdp();
    setDecorUI();
    const tk = ++decorToken;
    edit.classList.add('is-loading');
    const im = await loadDecor(d);
    if (tk !== decorToken) return;
    edit.classList.remove('is-loading');
    if (!im) return;
    S.decorImg = im;
    if (gl) upload('D', im, true);
    draw();
  }
  function setDecorUI() {
    $('[data-room-name]').textContent = S.decor.t;
    $$('[data-room-item]').forEach((li) => li.classList.toggle('is-on', +li.dataset.roomItem === S.decor.id));
    const cur = S.decor.id === DATA.current;
    $('[data-room-cta-l]').textContent = cur ? 'Cadrer et commander ce décor' : 'Voir ce décor';
    $('[data-room-w]').value = S.w; $('[data-room-h]').value = S.h;
  }

  /* =====================================================================
     Dessin
     ===================================================================== */
  let raf = 0;
  function draw() {
    if (raf || !gl || !S.photo || edit.hidden) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      if (!S.quad || !Hinv) return;
      if (S.maskDirty) { upload('M', S.mask); S.maskDirty = false; }
      const m = Hinv;
      gl.uniformMatrix3fv(U.uH, false, new Float32Array([m[0], m[3], m[6], m[1], m[4], m[7], m[2], m[5], m[8]]));
      gl.uniform2f(U.uS, S.pw, S.ph);
      const c = cropRect();
      gl.uniform4f(U.uC, c[0], c[1], c[2], c[3]);
      gl.uniform1f(U.uA, S.avg);
      gl.uniform1f(U.uK, S.light);
      gl.uniform1f(U.uShow, S.decorImg && !S.busy ? S.show : 0);
      const q = S.quad, side = Math.min(Math.hypot(q[2] - q[0], q[3] - q[1]), Math.hypot(q[6] - q[0], q[7] - q[1]));
      gl.uniform1f(U.uE, Math.min(0.02, 1.4 / Math.max(10, side)));
      const qw = Math.max(10, Math.hypot(q[2] - q[0], q[3] - q[1]));
      gl.uniform1f(U.uLes, S.w / 100);
      gl.uniform1f(U.uSeam, 1.1 / qw);
      const t = S.tint || [1, 1, 1];
      gl.uniform3f(U.uT, t[0], t[1], t[2]);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    });
  }

  /* =====================================================================
     Mise en page, coins, loupe
     ===================================================================== */
  let K = 1;
  function layout() {
    if (!S.photo) return;
    const sw = stage.clientWidth, sh = stage.clientHeight;
    K = Math.min(sw / S.pw, sh / S.ph);
    const w = S.pw * K, h = S.ph * K;
    fit.style.width = w + 'px'; fit.style.height = h + 'px';
    fit.style.left = (sw - w) / 2 + 'px'; fit.style.top = (sh - h) / 2 + 'px';
    $('[data-room-quad]').setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    placeHandles();
  }
  function placeHandles() {
    if (!S.quad) return;
    const q = S.quad, pts = [];
    handles.forEach((hd, i) => {
      const x = Math.max(0, Math.min(S.pw, q[i * 2])) * K, y = Math.max(0, Math.min(S.ph, q[i * 2 + 1])) * K;
      hd.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    for (let i = 0; i < 4; i++) pts.push((q[i * 2] * K).toFixed(1) + ',' + (q[i * 2 + 1] * K).toFixed(1));
    quadSvg.setAttribute('points', pts.join(' '));
  }
  window.addEventListener('resize', () => { if (dlg.open && !edit.hidden) layout(); });
  function toPhoto(e) {
    const r = fit.getBoundingClientRect();
    return [(e.clientX - r.left) / K, (e.clientY - r.top) / K];
  }

  handles.forEach((hd) => {
    const i = +hd.dataset.roomHandle;
    let st = null;
    hd.addEventListener('pointerdown', (e) => {
      if (S.mode !== 'place') return;
      e.preventDefault(); e.stopPropagation();
      hd.setPointerCapture(e.pointerId);
      const p = toPhoto(e);
      const qx = Math.max(0, Math.min(S.pw, S.quad[i * 2])), qy = Math.max(0, Math.min(S.ph, S.quad[i * 2 + 1]));
      st = { dx: qx - p[0], dy: qy - p[1] };
      hd.classList.add('is-drag'); edit.classList.add('is-dragging');
      setHint('');
    });
    hd.addEventListener('pointermove', (e) => {
      if (!st) return;
      const p = toPhoto(e);
      const x = Math.max(-S.pw * 0.02, Math.min(S.pw * 1.02, p[0] + st.dx));
      const y = Math.max(-S.ph * 0.02, Math.min(S.ph * 1.02, p[1] + st.dy));
      S.quad[i * 2] = x; S.quad[i * 2 + 1] = y;
      quadChanged();
      showLoupe(e, x, y);
    });
    const end = () => { if (!st) return; st = null; hd.classList.remove('is-drag'); edit.classList.remove('is-dragging'); loupe.classList.remove('is-on'); persistSoon(); };
    hd.addEventListener('pointerup', end); hd.addEventListener('pointercancel', end);
    hd.addEventListener('keydown', (e) => {
      const s = e.shiftKey ? 10 : 2, k = e.key;
      let dx = 0, dy = 0;
      if (k === 'ArrowLeft') dx = -s; else if (k === 'ArrowRight') dx = s; else if (k === 'ArrowUp') dy = -s; else if (k === 'ArrowDown') dy = s; else return;
      e.preventDefault();
      S.quad[i * 2] += dx / K; S.quad[i * 2 + 1] += dy / K; quadChanged();
    });
  });

  function showLoupe(e, x, y) {
    const sr = stage.getBoundingClientRect();
    const z = 2.4, sz = 110 / (K * z);
    lctx.clearRect(0, 0, 220, 220);
    lctx.save();
    lctx.beginPath(); lctx.arc(110, 110, 108, 0, Math.PI * 2); lctx.clip();
    lctx.fillStyle = '#eae6e2'; lctx.fillRect(0, 0, 220, 220);
    try { lctx.drawImage(S.photo, x - sz, y - sz, sz * 2, sz * 2, 0, 0, 220, 220); } catch (er) {}
    lctx.restore();
    lctx.strokeStyle = '#500E17'; lctx.lineWidth = 2;
    lctx.beginPath(); lctx.moveTo(110, 84); lctx.lineTo(110, 136); lctx.moveTo(84, 110); lctx.lineTo(136, 110); lctx.stroke();
    let lx = e.clientX - sr.left - 55, ly = e.clientY - sr.top - 150;
    if (ly < 6) ly = e.clientY - sr.top + 40;
    lx = Math.max(6, Math.min(sr.width - 116, lx));
    loupe.style.transform = 'translate(' + lx + 'px,' + ly + 'px)';
    loupe.classList.add('is-on');
  }

  /* =====================================================================
     Glisser dans le mur (choisir la partie du décor) ou retoucher
     ===================================================================== */
  let act = null;
  fit.addEventListener('pointerdown', (e) => {
    if (e.target.closest('[data-room-handle]') || !S.photo || S.busy) return;
    e.preventDefault();
    fit.setPointerCapture(e.pointerId);
    const p = toPhoto(e);
    if (S.mode === 'erase') {
      pushUndo();
      act = { type: 'paint', last: p };
      paint(p, p);
    } else if (Hinv) {
      const st = apply(Hinv, p[0], p[1]);
      if (st[0] >= 0 && st[0] <= 1 && st[1] >= 0 && st[1] <= 1) {
        const c = cropRect();
        act = { type: 'pan', st, cx: S.cx, cy: S.cy, vw: c[2], vh: c[3] };
      }
    }
  });
  fit.addEventListener('pointermove', (e) => {
    if (S.mode === 'erase') moveBrush(e);
    if (!act) return;
    const p = toPhoto(e);
    if (act.type === 'paint') { paint(act.last, p); act.last = p; }
    else if (act.type === 'pan' && Hinv) {
      const st = apply(Hinv, p[0], p[1]);
      S.cx = act.cx - (st[0] - act.st[0]) * act.vw;
      S.cy = act.cy - (st[1] - act.st[1]) * act.vh;
      draw();
    }
  });
  const endAct = () => {
    if (act && act.type === 'pan' && S.decor.id === DATA.current && pdp()) pdp().setCrop(S.cx, S.cy);
    if (act) persistSoon();
    act = null;
  };
  fit.addEventListener('pointerup', endAct); fit.addEventListener('pointercancel', endAct);
  fit.addEventListener('pointerleave', () => brush.classList.remove('is-on'));

  function paint(a, b) {
    const ctx = S.maskCtx, r = S.size / K / 2;
    const color = S.tool === 'erase' ? '0,0,0' : '255,255,255';
    const dist = Math.hypot(b[0] - a[0], b[1] - a[1]), n = Math.max(1, Math.ceil(dist / (r * 0.6)));
    for (let k = 0; k <= n; k++) {
      const x = (a[0] + (b[0] - a[0]) * k / n) / 2, y = (a[1] + (b[1] - a[1]) * k / n) / 2, rr = r / 2;
      const g = ctx.createRadialGradient(x, y, rr * 0.55, x, y, rr);
      g.addColorStop(0, 'rgba(' + color + ',1)'); g.addColorStop(1, 'rgba(' + color + ',0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, rr, 0, Math.PI * 2); ctx.fill();
    }
    S.maskDirty = true; draw();
  }
  function moveBrush(e) {
    if (e.pointerType === 'touch' && !act) { brush.classList.remove('is-on'); return; }
    const r = fit.getBoundingClientRect(), d = S.size;
    brush.style.width = brush.style.height = d + 'px';
    brush.style.transform = 'translate(' + (e.clientX - r.left - d / 2) + 'px,' + (e.clientY - r.top - d / 2) + 'px)';
    brush.classList.add('is-on');
  }
  function pushUndo() {
    try { S.undo.push(S.maskCtx.getImageData(0, 0, S.mask.width, S.mask.height)); } catch (e) {}
    if (S.undo.length > 8) S.undo.shift();
    $('[data-room-undo]').disabled = !S.undo.length;
  }
  $('[data-room-undo]').addEventListener('click', () => {
    const d = S.undo.pop(); if (d) { S.maskCtx.putImageData(d, 0, 0); S.maskDirty = true; draw(); persistSoon(); }
    $('[data-room-undo]').disabled = !S.undo.length;
  });
  $('[data-room-clear]').addEventListener('click', () => {
    pushUndo();
    if (S.segMask) { S.maskCtx.putImageData(S.segMask, 0, 0); S.maskDirty = true; } else fillMask(255);
    draw(); persistSoon();
  });

  /* =====================================================================
     Onglets (facultatifs) et réglages
     ===================================================================== */
  function setMode(m) {
    S.mode = m;
    $$('[data-room-mode]').forEach((b) => { const on = b.dataset.roomMode === m; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('[data-room-pane]').forEach((p) => { p.hidden = p.dataset.roomPane !== m; });
    edit.dataset.mode = m;
    brush.classList.remove('is-on');
    if (m === 'erase') setHint('Passez le doigt là où le décor déborde, ou là où il manque', 5000);
    else if (m === 'place') setHint('Glissez les ronds sur les angles du mur', 5000);
    else setHint('');
    placeHandles();
  }
  $$('[data-room-mode]').forEach((b) => b.addEventListener('click', () => setMode(S.mode === b.dataset.roomMode ? 'view' : b.dataset.roomMode)));
  $$('[data-room-tool]').forEach((b) => b.addEventListener('click', () => {
    S.tool = b.dataset.roomTool;
    $$('[data-room-tool]').forEach((o) => { const on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }));
  $('[data-room-size]').addEventListener('input', (e) => { S.size = +e.target.value; });
  $('[data-room-light]').addEventListener('input', (e) => { S.light = +e.target.value / 100; draw(); });
  $('[data-room-reset]').addEventListener('click', () => { resetQuad(); persistSoon(); });
  $('[data-room-new]').addEventListener('click', () => showPick());
  $('[data-room-retake]').addEventListener('click', () => { setMode('view'); showPick(); });

  const inW = $('[data-room-w]'), inH = $('[data-room-h]');
  const onDims = () => {
    const w = parseInt(inW.value, 10), h = parseInt(inH.value, 10);
    if (!(w >= 30 && h >= 30)) return;
    S.w = w; S.h = h; draw();
    if (pdp()) pdp().setDims(w, h);
  };
  inW.addEventListener('input', onDims); inH.addEventListener('input', onDims);

  const cmp = $('[data-room-cmp]');
  const hold = (v) => () => { S.show = v; cmp.classList.toggle('is-on', !v); draw(); };
  cmp.addEventListener('pointerdown', hold(0)); cmp.addEventListener('pointerup', hold(1));
  cmp.addEventListener('pointerleave', hold(1)); cmp.addEventListener('pointercancel', hold(1));
  cmp.addEventListener('contextmenu', (e) => e.preventDefault());

  let hintT;
  function setHint(t, ms) {
    clearTimeout(hintT);
    hint.textContent = t; hint.classList.toggle('is-on', !!t);
    if (t) hintT = setTimeout(() => hint.classList.remove('is-on'), ms || 6000);
  }

  /* =====================================================================
     Autres décors
     ===================================================================== */
  DATA.products.forEach((d) => {
    const li = document.createElement('li');
    li.dataset.roomItem = d.id;
    li.innerHTML = '<button type="button"><img src="' + d.th + '" alt="" loading="lazy" width="120" height="120"><span></span></button>';
    li.querySelector('span').textContent = d.t;
    li.querySelector('button').setAttribute('aria-label', 'Essayer ' + d.t);
    li.querySelector('button').addEventListener('click', () => { if (d.id !== S.decor.id) { setDecor(d); persistSoon(); } });
    strip.appendChild(li);
  });

  /* =====================================================================
     Suite : commander ou voir le décor
     ===================================================================== */
  $('[data-room-cta]').addEventListener('click', () => {
    if (S.decor.id === DATA.current) {
      const P = pdp();
      if (P) { P.setDims(S.w, S.h); P.setCrop(S.cx, S.cy); }
      close();
      if (P) setTimeout(() => P.openCfg(), 60);
    } else {
      persist();
      try { sessionStorage.setItem('vsm-room-open', '1'); } catch (e) {}
      window.location.href = S.decor.u;
    }
  });

  /* =====================================================================
     Garder l'image
     ===================================================================== */
  saveBtn.addEventListener('click', async () => {
    if (!gl || !S.photo) return;
    S.show = 1;
    await new Promise((r) => { draw(); requestAnimationFrame(() => requestAnimationFrame(r)); });
    const w = S.pw, band = Math.round(Math.max(44, S.ph * 0.07));
    const c = document.createElement('canvas'); c.width = w; c.height = S.ph + band;
    const x = c.getContext('2d');
    x.drawImage(cv, 0, 0);
    x.fillStyle = '#500E17'; x.fillRect(0, S.ph, w, band);
    x.fillStyle = '#F6F2EE';
    x.font = Math.round(band * 0.36) + 'px Georgia, serif';
    x.textBaseline = 'middle';
    x.fillText('Vue sur Mur · ' + S.decor.t, band * 0.4, S.ph + band / 2);
    x.font = Math.round(band * 0.26) + 'px ui-monospace, monospace';
    x.textAlign = 'right';
    x.fillText(S.w + ' × ' + S.h + ' cm', w - band * 0.4, S.ph + band / 2);
    c.toBlob(async (blob) => {
      if (!blob) return;
      const name = 'vue-sur-mur-' + S.decor.t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-') + '.jpg';
      const file = new File([blob], name, { type: 'image/jpeg' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try { await navigator.share({ files: [file], title: S.decor.t + ' chez moi' }); return; } catch (e) { if (e && e.name === 'AbortError') return; }
      }
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(a.href), 4000);
    }, 'image/jpeg', 0.9);
  });

  /* =====================================================================
     Mémoire de session (tout reste sur l'appareil)
     ===================================================================== */
  let pT;
  function persistSoon() { clearTimeout(pT); pT = setTimeout(persist, 600); }
  function persist() {
    if (!S.photo || S.busy) return;
    try {
      let photo = S.photoURL;
      if (!photo) {
        const k = Math.min(1, 1600 / Math.max(S.pw, S.ph));
        const c = document.createElement('canvas'); c.width = Math.round(S.pw * k); c.height = Math.round(S.ph * k);
        c.getContext('2d').drawImage(S.photo, 0, 0, c.width, c.height);
        photo = S.photoURL = c.toDataURL('image/jpeg', 0.84);
      }
      const seg = S.segMask ? (() => { const c = document.createElement('canvas'); c.width = S.segMask.width; c.height = S.segMask.height; c.getContext('2d').putImageData(S.segMask, 0, 0); return c.toDataURL('image/png'); })() : null;
      const o = { photo, pw: S.pw, ph: S.ph, quad: S.quad, autoQuad: S.autoQuad, mask: S.mask.toDataURL('image/png'), seg, light: S.light, w: S.w, h: S.h };
      sessionStorage.setItem(STORE, JSON.stringify(o));
    } catch (e) {}
  }
  function loadImg(src) { return new Promise((r) => { const im = new Image(); im.onload = () => r(im); im.onerror = () => r(null); im.src = src; }); }
  async function restore() {
    let o = null;
    try { o = JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) {}
    if (!o || !o.photo) return false;
    const im = await loadImg(o.photo);
    if (!im) return false;
    setPhoto(im, o.pw, o.ph);
    S.photoURL = o.photo;
    S.quad = o.quad; S.autoQuad = o.autoQuad || null;
    S.light = o.light != null ? o.light : 0.8;
    $('[data-room-light]').value = Math.round(S.light * 100);
    if (o.mask) { const m = await loadImg(o.mask); if (m) { S.maskCtx.drawImage(m, 0, 0, S.mask.width, S.mask.height); S.maskDirty = true; } }
    if (o.seg) {
      const s = await loadImg(o.seg);
      if (s) {
        const c = document.createElement('canvas'); c.width = S.mask.width; c.height = S.mask.height;
        const x = c.getContext('2d'); x.drawImage(s, 0, 0, c.width, c.height);
        S.segMask = x.getImageData(0, 0, c.width, c.height);
        /* lumière mesurée sur le mur (à partir du masque gardé) */
        const W = 128, H = 128, t = document.createElement('canvas'); t.width = W; t.height = H;
        const tx = t.getContext('2d', { willReadFrequently: true }); tx.drawImage(s, 0, 0, W, H);
        const dd = tx.getImageData(0, 0, W, H).data, prob = new Float32Array(W * H);
        for (let i = 0; i < W * H; i++) prob[i] = dd[i * 4] / 255;
        buildLight({ prob, W, H });
      }
    }
    quadChanged();
    if (dlg.open) showEdit();
    return true;
  }

  /* =====================================================================
     Démarrage
     ===================================================================== */
  if (!initGL()) {
    gl = null;
    $$('[data-open-room]').forEach((b) => { b.hidden = true; });
    return;
  }
  /* repère de version (test, à retirer au lancement) */
  const vtag = document.createElement('span'); vtag.className = 'vsm-room__ver'; vtag.textContent = 'v4'; stage.appendChild(vtag);
  setMode('view');
  let reopen = false;
  try { reopen = sessionStorage.getItem('vsm-room-open') === '1'; sessionStorage.removeItem('vsm-room-open'); } catch (e) {}
  setDecorUI();
  if (reopen) setTimeout(open, 300);
})();
